import React from "react";
import HibuButton from "./HibuButton";

class ReviewList extends React.Component {
  render() {
    const { merchant, writeDisable, truncateDest = "/reviews" } = this.props;
    if (merchant.numReviews == 0 && merchant.state === "cancelled") {
      return null;
    } else if (
      merchant.numReviews <= 4 &&
      merchant.state != "cancelled" &&
      !writeDisable
    ) {
      return <HibuButton url={merchant.surveyUrl} text="Write a Review" popUp={true}/>;
    } else {
      return <HibuButton url={truncateDest} text="Read More Reviews" />;
    }
  }
}

export default ReviewList;



// WEBPACK FOOTER //
// ./src/components/BottomButton.js